'use client';

/**
 * SPM 悬停检视器的加载门闸：仅 enabled 时渲染经 next/dynamic 懒加载的
 * SpmInspectorLoader（ssr:false，水合后按需拉取 chunk）。开关关闭时
 * import() 永不触发，检视器代码不进任何静态 chunk、浏览器不下载。
 *
 * ⚠️ 本文件与 barrel 必须对 ./spm-inspector-loader、./spm-inspector 保持
 * 零静态依赖：next/dynamic 只把代码拆成独立异步 chunk，「不下载」依赖的是
 * 没有任何静态 import 链把这两个模块拉进主包。检视器无可见 UI，加载晚于
 * 水合几十毫秒无感知。
 */

import dynamic from 'next/dynamic';

const SpmInspectorLoader = dynamic(
  () => import('./spm-inspector-loader').then((m) => m.SpmInspectorLoader),
  { ssr: false },
);

export function SpmInspectorGate({ enabled }: { enabled: boolean }) {
  return enabled ? <SpmInspectorLoader /> : null;
}
